class PropertyListings {
	constructor(el) {
		this.el = el;
		this.iframe = this.el.querySelector('.block-property-listings__iframe');

		if (!this.iframe) {
			return;
		}

		this.handleMessage = this.handleMessage.bind(this);
		window.addEventListener('message', this.handleMessage);
	}

	handleMessage(event) {
		if (event.source !== this.iframe.contentWindow || !Array.isArray(event.data)) {
			return;
		}

		const [action, height] = event.data;

		if (action !== 'setHeight' || !Number.isFinite(height) || height <= 0) {
			return;
		}

		this.iframe.height = Math.ceil(height);
	}
}

export default PropertyListings;
